<template>
  <div class="index">
    <div class="welcome">
      <b>系统管理员</b>您好！欢迎登陆平台
    </div>
    <div class="main-content">
      <div class="title-flex">
        <div class="title">
          <div class="icon-box">
            <i class="iconfont icon-tongji1"></i>
          </div>
          <b>机构概览</b>
        </div>
      </div>
      <div class="num-list">
        <div class="num-item icon1" @click="to('','')">
          <b>{{ info.gai.all }}</b>
          <p>教培机构数量</p>
          <img alt="" src="@/assets/images/icon1.png">
        </div>
        <!--                <div class="num-item icon2">-->
        <!--                    <b>{{ info.gai.percent }}%</b>-->
        <!--                    <p>机构信息完成率</p>-->
        <!--                    <img alt="" src="@/assets/images/icon2.png">-->
        <!--                </div>-->
        <div class="num-item icon3" @click="to(1,'')">
          <b>{{ info.gai.zheng }}</b>
          <p>培训许可证数量</p>
          <img alt="" src="@/assets/images/icon3.png">
        </div>
        <div class="num-item icon4" @click="$router.push('/admin/riskList')">
          <b>{{ info.gai.fengxian }}</b>
          <p>风险预警机构数量</p>
          <img alt="" src="@/assets/images/icon4.png">
        </div>
        <div class="num-item icon5" @click="to('',1)">
          <b>{{ info.gai.jianguan }}</b>
          <p>开通资金监管账户机构数量</p>
          <img alt="" src="@/assets/images/icon5.png">
        </div>
        <div class="num-item icon6">
          <b>{{ info.gai.baozhengjin }}<span>万元</span></b>
          <p>风险保证金金额</p>
          <img alt="" src="@/assets/images/icon6.png">
        </div>
        <div class="num-item icon7">
          <b>{{ info.gai.cunguan }}<span>万元</span></b>
          <p>银行存管账户金额</p>
          <img alt="" src="@/assets/images/icon7.png">
        </div>
      </div>
    </div>
    <div class="flex-box">
      <div class="all">
        <div class="main-content">
          <div class="title-flex">
            <div class="title">
              <div class="icon-box">
                <i class="iconfont icon-shouye3"></i>
              </div>
              <b>待办总览</b>
            </div>
          </div>
          <div class="list">
            <div class="list-item">
              <div class="item-icon icon1">
                <i class="iconfont icon-renwu"></i>
              </div>
              <div class="item-content">
                <p>待审核信息</p>
                <div class="flex justify-between align-center">
                  <b><span>{{ info.dai.shen.num }}</span>个</b>
                  <div class="item-bfenb">{{ info.dai.shen.percent }}</div>
                </div>
              </div>
            </div>
            <div class="list-item">
              <div class="item-icon icon2">
                <i class="iconfont icon-daishenhe"></i>
              </div>
              <div class="item-content">
                <p>预警待审核</p>
                <div class="flex justify-between align-center">
                  <b><span>{{ info.dai.jing_shen.num }}</span>个</b>
                  <div class="item-bfenb">{{ info.dai.jing_shen.percent }}</div>
                </div>
              </div>
            </div>
            <div class="list-item">
              <div class="item-icon icon3">
                <i class="iconfont icon-yujing"></i>
              </div>
              <div class="item-content">
                <p>预警提示督办</p>
                <div class="flex justify-between align-center">
                  <b><span>{{ info.dai.du.num }}</span>个</b>
                  <div class="item-bfenb">{{ info.dai.du.percent }}</div>
                </div>
              </div>
            </div>
            <div class="list-item">
              <div class="item-icon icon4">
                <i class="iconfont icon-renyuanyichang"></i>
              </div>
              <div class="item-content">
                <p>异议申诉处理</p>
                <div class="flex justify-between align-center">
                  <b><span>{{ info.dai.shensu.num }}</span>个</b>
                  <div class="item-bfenb">{{ info.dai.shensu.percent }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="daiban">
        <div class="main-content">
          <div class="title-flex">
            <div class="title">
              <div class="icon-box">
                <i class="iconfont icon-daiban"></i>
              </div>
              <b>待办事项</b>
            </div>
            <div class="daibannum">
              共计待办事项
              <b>{{
                  info.daiLst.shen.length + info.daiLst.jing_shen.length + info.daiLst.du.length + info.daiLst.shensu.length + info.daiLst.out.length
                }}</b>
            </div>
          </div>
          <div class="tab-flex">
            <span :class="{active:active == 0}" @click="tabClick(0)">待审核信息  {{ info.daiLst.shen.length }}</span>
            <span :class="{active:active == 1}" @click="tabClick(1)">预警待审核  {{ info.daiLst.jing_shen.length }}</span>
            <span :class="{active:active == 2}" @click="tabClick(2)">预警督办  {{ info.daiLst.du.length }}</span>
            <span :class="{active:active == 3}" @click="tabClick(3)">异议申诉处理  {{ info.daiLst.shensu.length }}</span>
            <span :class="{active:active == 4}" @click="tabClick(4)">到期提醒  {{ info.daiLst.out.length }}</span>
          </div>
          <div class="shixiang scroll">
            <div class="sx-content">
              <div v-for="(item,index) in lists" :key="index" class="item"
                   @click="todoClick(item)">
                <div class="dian"></div>
                <div class="tex ovHide">{{ item.org_name }}</div>
                <div class="type" v-if="active != 4">{{ active | active }}</div>
                <div class="type" v-else >{{ item.info}}</div>
                <!--                         <div class="time">2525-09-14 12:12:12</div>-->
              </div>
              <el-empty v-if="lists.length == 0"></el-empty>
            </div>
          </div>
        </div>
      </div>
      <div class="tongzhi">
        <div class="main-content">
          <div class="title-flex">
            <div class="title">
              <div class="icon-box">
                <i class="iconfont icon-tongzhi"></i>
              </div>
              <b>通知公告</b>
            </div>
            <router-link to="/admin/notice" class="more">
              查看更多<i class="iconfont icon-jiantou_yemian_xiangyou_o"></i>
            </router-link>
          </div>
          <div class="notice">
            <router-link :to="`/admin/detail?id=${item.id}`" class="item" v-for="(item,index) in info.tongzhi"
                         :key="index">
              <div class="yuan"></div>
              <div class="tex ovHide">{{ item.title }}</div>
              <div class="time">{{ item.publish_time }}</div>
            </router-link>
            <el-empty v-if="info.tongzhi.length == 0"></el-empty>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-box">
      <div class="pingding">
        <div class="main-content">
          <div class="title-flex">
            <div class="title">
              <div class="icon-box">
                <i class="iconfont icon-shoucang_xuanzhong"></i>
              </div>
              <b>星级评定</b>
            </div>
          </div>
          <div class="flex justify-center">
            <div class="xingp-box">
              <div class="select-box">
                <el-select v-model="start_id_1" placeholder="请选择" style="width: 100%;" @change="getHomeStarsIndex_1">
                  <el-option
                    v-for="item in starList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div class="chart-box">
                <div id="chart1" class="chart"></div>
              </div>
            </div>
            <div class="xingp-box">
              <div class="select">
                <el-select v-model="start_id_2" placeholder="请选择" style="width: 100%;" @change="getHomeStarsIndex_2">
                  <el-option
                    v-for="item in starList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div class="chart-box">
                <div id="chart2" class="chart"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="jigou">
        <div class="main-content">
          <div class="title-flex">
            <div class="title">
              <div class="icon-box">
                <i class="iconfont icon-jigou1"></i>
              </div>
              <b>星级评定机构情况</b>
            </div>
          </div>
          <div class="xp-box scroll">
            <div class="xp-list">
              <div v-for="(item, index) in info.xing" :key="index" :class="`level${item.star}`" class="xp-item">
                <div class="xp-level">{{ item.star | star }}星级</div>
                <div class="xp-name ovHide">{{ item.org_name }}</div>
                <div class="xp-sorce">{{ item.score }}分</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="yj-container  margin-top-sm">
      <div class="title-flex">
        <div class="flex align-center">
          <div class="title red">
            <div class="icon-box">
              <i class="iconfont icon-yujing"></i>
            </div>
            <b>风险预警</b>
          </div>
          <div class="select margin-left-xl">
            <el-select v-model="level" placeholder="请选择" style="width: 100%;z-index: 1" @change="getHomeWarningIndex">
              <el-option
                v-for="item in riskLevelAllOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div id="yj_echart" class="yj-echart"></div>
      <el-table
        :data="info.jing"
        :header-cell-style="centerbgc"
        border
        height="570"
        style="width: 100%;">
        <el-table-column
          label="状态"
          prop="name"
          width="250" align="center">
          <template slot-scope="scope">
            <span class="level" :class="getLevelClass(scope.row.level)">{{ scope.row.level | level }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="机构名称"
          prop="org_name"
          width="250" align="center">
        </el-table-column>
        <el-table-column
          label="预警提示"
          prop="info" align="center">
        </el-table-column>
        <el-table-column
          label="时间"
          prop="create_time"
          width="250" align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          prop="name"
          width="250" align="center">
          <template slot-scope="scope" class="flex">
            <el-link type="primary" @click="addItem(scope.row)">查看</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <add-risk-dialog :dialog-visible="addRiskDialog" :id="cur_id" type @handleClose="handleClose"></add-risk-dialog>
    <apply-risk-dialog :dialog-visible="applyRiskDialog" :id="cur_id" @handleClose="handleClose"></apply-risk-dialog>
    <duban-risk-dialog :dialog-visible="dubanRiskDialog" :id="cur_id" @handleClose="handleClose"></duban-risk-dialog>

  </div>
</template>
<script>
import * as echarts from 'echarts';
import {getEvaluateList, getEvaluationTotal, getHomeIndex, getHomeWarningIndex} from "@/api/admin";
import AddRiskDialog from "@/views/admin/pages/risk/common/addRiskDialog";
import {findByType} from "@/utils/utils";
import {riskLevelAllOptions} from "@/utils/const";
import ApplyRiskDialog from "@/views/admin/pages/risk/common/applyRiskDialog";
import DubanRiskDialog from "@/views/admin/pages/risk/common/dubanRiskDialog";

export default {
  name: "index",
  data() {
    return {
      riskLevelAllOptions: riskLevelAllOptions,
      info: {
        gai: {},
        dai: {
          shen: {},
          jing_shen: {},
          du: {},
          shensu: {},
        },

        daiLst: {
          shen: [],
          jing_shen: [],
          du: [],
          shensu: [],
          out: [],
        },
        tongzhi: [],
        xing: [],
        jing: [],
      },
      active: 0,
      lists: [],

      cur_id: '',
      addRiskDialog: false,
      applyRiskDialog: false,
      dubanRiskDialog: false,

      level: '',
      starList: [],

      start_id_1: '',
      start_id_2: '',

      option: {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: '5%',
          left: 'center',
          icon: 'circle',
        },
        color:['#ff2e2e','#ffc20a','#b08dcb','#00b0f0','#00b050','#a3aaad'],
        series: {
          name: '',
          type: 'pie',
          radius: ['40%', '60%'],
          avoidLabelOverlap: true,
          emphasis: {
            label: {
              show: true,
              fontSize: 20,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          },
          data: [],

        }
      },

      bar_option: {
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
        },
        legend: {
          show: true,
          right: '30px',
          top: '50px',
          icon: 'roundRect',
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 6,
          textStyle: {
            fontSize: 10,
            color: '#666666'
          },
          data: ['上年度', '本年度']
        },
        grid: {
          left: '30px',
          right: '30px',
          bottom: '30px',
          top: '120px'
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999'
          }
        },
        series: [
          {
            type: 'bar',
            name: '上年度',
            barWidth: 29,
            itemStyle: {
              color: '#ffdddd'
            },
            data: []
          },
          {
            type: 'bar',
            name: '本年度',
            showBackground: true,
            barWidth: 29,
            itemStyle: {
              color: '#fc5a5a'
            },
            backgroundStyle: {
              borderWidth: 32,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {offset: 0, color: '#ffebeb00'},
                {offset: 1, color: '#ffebeb'}
              ])
            },
            data: []
          }
        ]
      }
    }
  },
  components: {DubanRiskDialog, ApplyRiskDialog, AddRiskDialog},
  computed: {
    centerbgc() {
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  created() {
    this.$emit("setActive", {
      headActive: 1
    })
  },
  mounted() {
    this.init()
    this.getHomeWarningIndex()
  },
  methods: {
    async init() {
      let _data = await getEvaluateList(
        '',
        '',
        '',
        1,
        1000
      )
      this.starList = _data.data.data
      this.start_id_1 = this.starList[0].id
      this.start_id_2 = this.starList[0].id
      this.getHomeStarsIndex_1()
      this.getHomeStarsIndex_2()
      _data = await getHomeIndex()
      this.info = _data.data
      this.tabClick(this.active)
    },
    async getHomeWarningIndex() {
      let _data = await getHomeWarningIndex(this.level)
      this.bar_option.series[0].data = Object.values(_data.data.last_year_arr)
      this.bar_option.series[1].data = Object.values(_data.data.year_arr)
      echarts.init(document.getElementById('yj_echart')).setOption(this.bar_option)
    },
    async getHomeStarsIndex_1() {
      let _data = await getEvaluationTotal(this.start_id_1)
      this.option.series.data = [
        {value: _data.data.one_star.num, name: `一星级${_data.data.one_star.num}-${_data.data.one_star.percent}%`},
        {value: _data.data.two_star.num, name: `二星级${_data.data.two_star.num}-${_data.data.two_star.percent}%`},
        {value: _data.data.three_star.num, name: `三星级${_data.data.three_star.num}-${_data.data.three_star.percent}%`},
        {value: _data.data.four_star.num, name: `四星级${_data.data.four_star.num}-${_data.data.four_star.percent}%`},
        {value: _data.data.five_star.num, name: `五星级${_data.data.five_star.num}-${_data.data.five_star.percent}%`},
      ]
      echarts.init(document.getElementById('chart1')).setOption(this.option)
    },
    async getHomeStarsIndex_2() {
      let _data = await getEvaluationTotal(this.start_id_2)
      this.option.series.data = [
        {value: _data.data.one_star.num, name: `一星级${_data.data.one_star.num}-${_data.data.one_star.percent}%`},
        {value: _data.data.two_star.num, name: `二星级${_data.data.two_star.num}-${_data.data.two_star.percent}%`},
        {value: _data.data.three_star.num, name: `三星级${_data.data.three_star.num}-${_data.data.three_star.percent}%`},
        {value: _data.data.four_star.num, name: `四星级${_data.data.four_star.num}-${_data.data.four_star.percent}%`},
        {value: _data.data.five_star.num, name: `五星级${_data.data.five_star.num}-${_data.data.five_star.percent}%`},
      ]
      echarts.init(document.getElementById('chart2')).setOption(this.option)
    },
    tabClick(active) {
      this.active = active
      if (this.active == 0) {
        this.lists = this.info.daiLst.shen
      } else if (this.active == 1) {
        this.lists = this.info.daiLst.jing_shen
      } else if (this.active == 2) {
        this.lists = this.info.daiLst.du
      } else if (this.active == 3) {
        this.lists = this.info.daiLst.shensu
      } else {
        this.lists = this.info.daiLst.out
      }
    },
    todoClick(item) {
      switch (this.active) {
        case 0:
          // this.$router.push(`/admin/orgApply?org_id=${item.id}`)
          this.$router.push(`/admin/orgApply?org_id=${item.id}`)
          break;
        case 1:
          // this.cur_id = item ? item.id : ''
          // this.applyRiskDialog = true
          this.$router.push(`/admin/riskList`)
          break;
        case 2:
          this.$router.push(`/admin/riskList`)
          // this.cur_id = item ? item.id : ''
          // this.dubanRiskDialog = true
          break;
        case 3:
          this.$router.push(`/admin/objectionAppealList`)
          break;
        case 4:
          this.$router.push(`/admin/orgDetail?org_id=${item.id}&org_name=&license=&jianguan=&is_lock=&peixun_lei=&active=1&page=1`)
          break;
      }
    },

    to(license,jianguan){
      this.$router.push({
        path: '/admin/orgList',
        query: {
          license: license,
          jianguan:jianguan,
        }
      })
    },

    addItem(data) {
      this.cur_id = data ? data.id : ''
      this.addRiskDialog = true
    },
    handleClose(data) {
      if (data) this.init()
      this.addRiskDialog = false
      this.dubanRiskDialog = false
      this.applyRiskDialog = false
    },
    getLevelClass(val) {
      return findByType(riskLevelAllOptions, val, {key: 'value', value: 'type'})
    },
  },
  watch: {},
  filters: {
    level(val) {
      let label = findByType(riskLevelAllOptions, val);
      return label.substring(label.length - 2)
    },
    active(val) {
      switch (val) {
        case 0:
          return '待审核信息';
        case 1:
          return '预警待审核';
        case 2:
          return '预警督办';
        case 3:
          return '异议申诉处理';
          case 4:
          return '到期提醒';
      }
    },
    star(val) {
      switch (val) {
        case 1:
          return '一';
        case 2:
          return '二';
        case 3:
          return '三';
        case 4:
          return '四';
        case 5:
          return '五';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.level {
  background-color: #f2f2f2;
  border-radius: 4px;
  font-size: 14px;
  line-height: 26px;
  text-align: center;
  color: #8a8a8a;
  width: 60px;
  height: 26px;
  display: inline-block;

  &.text {
    width: unset !important;
    height: unset !important;
    background: none !important;
  }

  &.green {
    background-color: #d9f7be;
    color: #0e7701;
  }

  &.red {
    background-color: #ffdddd;
    color: #f8001a;
  }

  &.yellow {
    background-color: #fffbdd;
    color: #fad471;
  }

  &.orange {
    background-color: #ffeddd;
    color: #f58739;
  }
}

.index {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;

  .welcome {
    width: 100%;
    text-align: right;
    font-size: 14px;
    color: #2892ff;
    padding-bottom: 15px;

    b {
      font-weight: bold;
    }
  }

  .title-flex {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #e3e7f0;
    position: relative;
  }

  .title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 60px;

    &.red {
      .icon-box {
        background-image: linear-gradient(-30deg,
          #f8001a 0%,
          #f9746c 100%);
        box-shadow: 0px 10px 10px 0px rgba(255, 99, 92, 0.3);
      }
    }

    b {
      font-size: 22px;
      color: #16181d;
      font-weight: bold;
      margin-left: 10px;
    }

    .icon-box {
      width: 30px;
      height: 30px;
      background-image: linear-gradient(-30deg,
        #3579fb 0%,
        #44a3ff 100%);
      box-shadow: 0px 10px 10px 0px rgba(50, 150, 255, 0.3);
      border-radius: 10px;
      text-align: center;
      line-height: 30px;

      i {
        font-size: 17px;
        color: #ffffff;
      }
    }
  }

  .yj-container {
    background-image: linear-gradient(0deg,
      #ffffff 89%,
      #ffeaea 100%);
    border-radius: 10px;
    border: solid 1px #ffffff;
    padding: 15px 20px;

    .yj-echart {
      width: 100%;
      height: 500px;
      margin-top: -100px;
    }
  }

  .flex-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-top: 20px;

    .pingding {
      width: 1280px;
      height: 630px;

      .xingp-box {
        width: 550px;
        margin: 20px 30px;

        .select-box {
          width: 100%;
        }

        .chart-box {
          width: 100%;
          height: 460px;

          .chart {
            width: 100%;
            height: 460px;
          }
        }
      }
    }

    .jigou {
      width: 582px;
      height: 630px;
      flex: 1;
      margin-left: 20px;

      .xp-box {
        width: 100%;
        height: 520px;
        margin-top: 20px;
        overflow-y: auto;

        .xp-list {
          width: 100%;
          height: max-content;
          padding-right: 3px;

          .xp-item {
            width: 100%;
            height: 41px;
            border-radius: 4px;
            padding: 0 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;

            .xp-level {
              width: 44px;
              height: 17px;
              border-radius: 2px;
              text-align: center;
              line-height: 17px;
              font-size: 12px;
              color: #ffffff;
            }

            .xp-name {
              flex: 1;
              width: 0;
              padding: 0 20px;
              font-size: 15px;
              color: #16181d;
            }

            .xp-sorce {
              font-size: 15px;
              color: #16181d;
              width: 50px;
              text-align: right;
            }

            &.level1 {
              background-image: linear-gradient(90deg,
                #e9efff 0%,
                #fcfcfd 100%);
              border: solid 1px #bbd0fa;

              .xp-level {
                background-image: linear-gradient(-36deg,
                  #3e7bfa 0%,
                  #97b9ff 100%);
                box-shadow: 2px 2px 5px 0px rgba(62, 123, 250, 0.4);
              }
            }

            &.level2 {
              background-image: linear-gradient(90deg,
                #fffae9 0%,
                #fdfdfc 100%);
              border: solid 1px #fae5bb;

              .xp-level {
                background-image: linear-gradient(-36deg,
                  #ff9d32 0%,
                  #ffc27f 100%);
                box-shadow: 2px 2px 5px 0px rgba(255, 158, 52, 0.4);
              }
            }

            &.level3 {
              background-image: linear-gradient(90deg,
                #e9ffef 0%,
                #fcfdfc 100%);
              border: solid 1px #ccf4cb;

              .xp-level {
                background-image: linear-gradient(-36deg,
                  #75c773 0%,
                  #a2dea0 100%);
                box-shadow: 2px 2px 5px 0px rgba(117, 199, 115, 0.4);
              }
            }

            &.level4 {
              background-image: linear-gradient(90deg,
                #f1e9ff 0%,
                #fcfcfd 100%);
              border: solid 1px #e3d8ed;

              .xp-level {
                background-image: linear-gradient(-36deg,
                  #6f4efe 0%,
                  #ac99ff 100%);
                box-shadow: 2px 2px 5px 0px rgba(111, 78, 254, 0.4);
              }
            }

            &.level5 {
              background-image: linear-gradient(90deg,
                #ffe9e9 0%,
                #fdfcfc 100%);
              border: solid 1px #ffc3c3;

              .xp-level {
                background-image: linear-gradient(-36deg,
                  #ff6853 0%,
                  #ff9789 100%);
                box-shadow: 2px 2px 5px 0px rgba(255, 63, 63, 0.4);
              }
            }

          }
        }
      }
    }


    .all {
      width: 437px;
      height: 410px;

      .list {
        width: 100%;
        height: 300px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        margin-top: 10px;

        .list-item {
          width: 100%;
          height: 62px;
          border-radius: 8px;
          padding: 5px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          &:nth-child(2n) {
            background-color: #f8faff;
          }

          .item-content {
            flex: 1;
            height: 52px;
            padding: 3px 30px;
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            .item-bfenb {
              font-size: 14px;
              color: #a5a7ae;
            }

            b {
              font-size: 14px;
              color: #a5a7ae;
              line-height: inherit;

              span {
                font-size: 18px;
                color: #16181d;
                margin-right: 4px;
              }
            }

            p {
              width: 100%;
              font-size: 14px;
              color: #333333;
              line-height: inherit;
            }
          }

          .item-icon {
            width: 48px;
            height: 48px;
            text-align: center;
            line-height: 48px;
            border-radius: 8px;

            i {
              font-size: 30px;
              color: #ffffff;
            }

            &.icon1 {
              background-color: #ffcc3e;
              box-shadow: 4px 5px 16px 2px rgba(255, 204, 63, 0.4);
            }

            &.icon2 {
              background-color: #ff9065;
              box-shadow: 4px 5px 16px 2px rgba(255, 144, 101, 0.4);
            }

            &.icon3 {
              background-color: #447cf7;
              box-shadow: 4px 5px 16px 2px rgba(63, 123, 250, 0.4);
            }

            &.icon4 {
              background-color: #44d6a9;
              box-shadow: 4px 5px 16px 2px rgba(68, 214, 169, 0.4);
            }
          }
        }
      }
    }

    .daiban {
      width: 820px;
      height: 410px;
      flex: 1;
      margin: 0 20px;
    }

    .tongzhi {
      width: 585px;
      height: 410px;
    }
  }

  .main-content {
    width: 100%;
    height: 100%;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #edf6ff 100%);
    padding: 0 20px;
    border-radius: 10px;
    padding-top: 10px;

    .notice {
      width: 100%;

      .item {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        margin-top: 25px;

        &.new {
          .tex {
            color: #5198e2;
          }

          .time {
            color: #5198e2;
          }
        }

        &.old {
          .tex {
            color: #cbd0d9;
          }

          .time {
            color: #cbd0d9;
          }
        }

        .time {
          flex: 1;
          text-align: right;
          font-size: 14px;
          color: #bdc4d2;
        }

        .tex {
          max-width: 320px;
          width: max-content;
          font-size: 16px;
          color: #16181d;
        }

        .yuan {
          width: 8px;
          height: 8px;
          background-color: #2791ff;
          border-radius: 4px;
          margin-right: 15px;
        }
      }
    }

    .shixiang {
      width: 100%;
      height: 260px;
      overflow-y: auto;
      padding-right: 5px;
      .sx-content {
        width: 100%;
        height: max-content;
        .item {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          cursor: pointer;
          margin-top: 25px;
          margin-bottom: 4px;

          .dian {
            width: 10px;
            height: 10px;
            background-color: #eea14e;
            border-radius: 5px;
            margin-right: 15px;
          }

          .time {
            flex: 1;
            text-align: right;
            font-size: 14px;
            color: #bdc4d2;
          }

          .type {
            height: 22px;
            background-color: #f1f8ff;
            border-radius: 4px;
            padding: 0 10px;
            text-align: center;
            line-height: 22px;
            font-size: 12px;
            color: #2791ff;
            margin: 0 15px;
          }

          .tex {
            max-width: 435px;
            width: max-content;
            font-size: 16px;
            color: #16181d;

            &:hover {
              color: #5198e2;
            }
          }
        }
      }
    }

    .tab-flex {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-bottom: 1px solid #ededed;
      padding: 15px;

      span {
        height: 29px;
        background-color: #f6f7fa;
        border-radius: 4px;
        line-height: 28px;
        padding: 0 15px;
        font-size: 14px;
        color: #a5a7ae;
        margin-right: 15px;
        cursor: pointer;

        &.active {
          background-color: #2791ff;
          color: #ffffff;
        }
      }
    }


    .num-list {
      width: 100%;
      padding: 30px 0;
      display: flex;
      justify-content: space-between;

      .num-item {
        flex: 1;
        margin-right: 20px;
        width: 295px;
        height: 170px;
        padding: 25px;
        padding-top: 20px;
        border-radius: 10px;
        position: relative;
        &:last-child {
          margin-right: 0;
        }

        img {
          position: absolute;
          bottom: 15px;
          right: 15px;
        }

        p {
          font-size: 16px;
          color: #ffffff;
        }

        b {
          font-size: 36px;
          color: #ffffff;
          font-weight: bold;
          display: block;

          span {
            font-size: 18px;
            font-weight: normal;
          }
        }

        &.icon1 {
          background-image: linear-gradient(-55deg,
            #6499ff 0%,
            #3670f0 100%);
        }

        &.icon2 {
          background-image: linear-gradient(-55deg,
            #c38dff 0%,
            #9a50ff 100%);
        }

        &.icon3 {
          background-image: linear-gradient(-55deg,
            #ff8dd8 0%,
            #ec50ff 100%);
        }

        &.icon4 {
          background-image: linear-gradient(-55deg,
            #ffa18d 0%,
            #ff6950 100%);
        }

        &.icon5 {
          background-image: linear-gradient(-55deg,
            #54d278 0%,
            #39c49b 100%);
        }

        &.icon6 {
          background-image: linear-gradient(-55deg,
            #ffb76b 0%,
            #ff8c13 100%);
        }

        &.icon7 {
          background-image: linear-gradient(-55deg,
            #6bd3ff 0%,
            #13a3ff 100%);
        }
      }
    }

    .more {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 14px;
      color: #2791ff;

      i {
        font-size: 16px;
        color: #2791ff;
        margin-left: 5px;
      }
    }

    .daibannum {
      width: 154px;
      height: 43px;
      background: url("../../../assets/images/daibanbgc.png") no-repeat;
      background-size: 100% 100%;
      line-height: 35px;
      text-align: center;
      position: absolute;
      top: 16px;
      right: -26px;
      font-size: 16px;
      color: #ffffff;

      b {
        font-weight: bold;
        margin-left: 4px;
      }
    }
  }
}
</style>


